export const languageCodeMapping = [
  { sitecore: 'en', lotAPI: '1' },
  { sitecore: 'zh', lotAPI: '3' },
  { sitecore: 'zh-cn', lotAPI: '4' },
]
